<div class="wrapper-main-public-area">
  <div class="welcomeInfoText font30 mb-0 pt-5 pb-3 text-white d-flex justify-content-right">
    <a class="back-menu" routerLink="/user/login">
      <div class="line1">
        <div class="line2"></div>
      </div>
    </a>
  </div>
  <div class="text-block text-white">
    @if (activationNOTOK) {
      <div class="text-block"><br/><br/>There was a problem with your account activation.<br/>Please, contact support.</div>
    }
    @if (activationLinkSent) {
      <div class="text-block"><br/><br/>The new link has been sent to your email address.</div>
    }
  </div>
</div>